import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import FontAwesomeButton from "../cards/FontAwesomeButton";

const FilterRibbon = ({onClear, onCommit, bonusContent = null}) => (
    <div style={{paddingTop: "0.75rem", display: "flex", justifyContent: "space-between"}} className={"filter-ribbon"}>
        {onClear ? <FontAwesomeButton
            icon={faTrash}
            onClick={onClear}
        /> : <div/>}
        {bonusContent}
        {onCommit ? <FontAwesomeButton
            icon={faSearch}
            onClick={onCommit}
        /> : <div/>}
    </div>
)

export default FilterRibbon;